<template>
  <v-list
    class="text-left"
    :two-line="jobType === 'ADM'"
  >
    <v-list-item v-for="(establishment, index) in items" :key="index">
      <v-list-item-icon>
        <v-icon>mdi-school</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ establishment.name }}</v-list-item-title>

        <v-list-item-subtitle v-if="establishment.charge">
          {{ establishment.charge }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="showActions">
        <v-btn @click="$emit('remove-establishment', establishment)" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'EstablishmentList',

  props: {
    items: Array,
    jobType: String,
    showActions: Boolean,
  },
};
</script>
